import Vue from 'vue';
import Axios from 'axios';
import i18n from '../../i18n';
import { API_HOST } from '../../config/app-const';

const state = {
  languages: {
    isBusy: false,
    data: null,
    error: null
  }
};

const getters = {
  languages: (state) => {
    if (!state.languages.data) return [];

    return state.languages.data.data;
  },
  languagesOptions: (state, getters) => {
    if (!getters.languages || !getters.languages.length) return [];

    return getters.languages.map(item => {
      return { value: item.alpha_2_code, label: item.name };
    });
  },
}

const mutations = {
  LOAD_LANGUAGES_BUSY: (state, payload) => {
    state.languages.isBusy = payload;
  },
  LOAD_LANGUAGES_SUCCESS: (state, payload) => {
    state.languages.data = payload;
    state.languages.error = null;
  },
  LOAD_LANGUAGES_FAIL: (state, payload) => {
    state.languages.data = null;
    state.languages.error = payload;
  }
};

const actions = {
  getLanguages: ({ commit, rootState, getters }, { projectId, force = false }) => {
    return new Promise((result, reject) => {
      if (getters.languages.length && !force) return reject();

      commit('LOAD_LANGUAGES_BUSY', true);

      const { accessToken } = rootState.user.user.data;
      const config = {
        headers: { Authorization: `Token token=${accessToken}` }
      };

      return Axios
        .get(`${API_HOST}/analysis/editor/${projectId}/languages`, config)
        .then(response => {
          commit('LOAD_LANGUAGES_SUCCESS', response.data)
          result(response);
        })
        .catch(error => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error')
          });

          console.error(error);
          commit('LOAD_LANGUAGES_FAIL', error);
          reject(error);
        })
        .finally(() => commit('LOAD_LANGUAGES_BUSY', false));
    })
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};